// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3OAkn","list":"BalanceDue_list__1CEqd","listRow":"BalanceDue_listRow__3ukRK","total":"BalanceDue_total__2QpAc"};